import React from 'react';
import { RadioButtonGroup } from '@roger/ui-components';
import { Question } from '../types';

interface RadioQuestionProps {
  question: Question;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const RadioQuestion: React.FC<RadioQuestionProps> = ({
  question,
  value,
  onChange,
  disabled = false,
}) => {
  if (!question.values) {
    return <div className='text-red-600'>Radio question missing values</div>;
  }

  const options = question.values.map(val => ({
    value: val,
    label: question.value_description?.[val]
      ? `${val} - ${question.value_description[val]}`
      : val,
  }));

  // Use horizontal layout when options are short enough to fit
  const totalLabelLength = options.reduce(
    (sum, opt) => sum + opt.label.length,
    0
  );
  const useHorizontal = options.length <= 5 && totalLabelLength < 100;

  return (
    <div className='space-y-2'>
      <label className='text-sm font-semibold text-foreground block'>
        {question.question || question.description}
      </label>

      <RadioButtonGroup
        options={options}
        value={value || ''}
        onValueChange={onChange}
        disabled={disabled}
        allowDeselect
        orientation={useHorizontal ? 'horizontal' : 'vertical'}
        className={useHorizontal ? 'flex flex-wrap gap-4' : 'gap-2'}
      />
    </div>
  );
};
